export default __webpack_public_path__ + "static/media/home.043bb319.svg";